/**
 * Session mode at the start (S-21, owner ruling 2026-10-14): the app's
 * pre-selected guess, kept to the modes the workflow allows. The chooser is
 * SessionModeChooser; this is the rule it pre-selects with.
 */
import type { SessionContextMode } from '../../types/prioritization/workflow';

/** The app's best guess, as session start inferred it before S-21. */
export function inferSessionMode(input: { cycleId?: string | null; trackId?: string | null }): SessionContextMode {
  return input.cycleId && input.trackId ? 'cycle_linked' : 'app_linked';
}

/** The guess, moved to the first allowed mode when the workflow does not allow it. */
export function preselectSessionMode(
  input: { cycleId?: string | null; trackId?: string | null },
  allowed: readonly SessionContextMode[],
): SessionContextMode {
  const guess = inferSessionMode(input);
  if (allowed.includes(guess)) return guess;
  const usable = allowed.filter((m) => m !== 'cycle_linked' || (input.cycleId && input.trackId));
  return usable[0] ?? allowed[0] ?? guess;
}

